import { render, staticRenderFns } from "./DialogSelectProduct.vue?vue&type=template&id=b725cbfa&scoped=true"
import script from "./DialogSelectProduct.vue?vue&type=script&lang=js"
export * from "./DialogSelectProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b725cbfa",
  null
  
)

export default component.exports